<template>
  <div class="page">
    <Header title="选择卡券" :leftHandler="selectCoupon"/>
    <div class="coupon-list">
      <div v-for="coupon in couponList" :key="coupon.couponId" @click="selectCoupon(coupon)" >
        <Coupon  :coupon=coupon type="selected"></Coupon>
      </div>
        <p class="text-center coupon-list" v-if="!couponList.length">没有更多了</p>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import cartApi from '@/api/cart'
import Coupon from '@/components/coupon'
export default {
  components: {
    Header,
    Coupon
  },
  data () {
    return {
      couponId: null,
      addressId: null,
      couponList: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.couponId = this.$route.params.selectCouponId || null
      this.addressId = this.$route.params.selectAddressId || null
      this.initCreateOrder()
    },
    initCreateOrder () {
      cartApi.initCreateOrder().then(res => {
        if (res.data.resultCode === '0') {
          const { couponList } = res.data.resultData
          this.couponList = couponList || []
          this.couponList.forEach(e => {
            e.ischeck = Boolean(e.couponId === this.couponId)
          })
        }
      })
    },
    selectCoupon (item) {
      this.$router.replace({
        name: 'orderCreate',
        params: {
          selectCouponId: item ? item.couponId : this.couponId,
          newAddressId: this.addressId
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.coupon-list{
    padding: 0.2rem;
}
</style>
